import type React from 'react';

/**
 * Replace locale comma with period so iOS keyboards that show "," instead of
 * "." as the decimal separator still produce valid float strings.
 */
export function normalizeDecimal(raw: string): string {
  return raw.replace(',', '.');
}

/**
 * Scroll the focused input into the center of the visual viewport after the
 * iOS keyboard animation finishes (~300 ms). Prevents the fixed/absolute
 * footer from overlapping the active input field.
 */
export function scrollInputIntoView(e: React.FocusEvent<HTMLInputElement>): void {
  const el = e.currentTarget;
  setTimeout(() => {
    el.scrollIntoView({ behavior: 'smooth', block: 'center' });
  }, 350);
}
